import * as React from 'react';
import {Button, ButtonColor, ButtonSize, ButtonType} from "@atoms/LinksAndButtons/Button";
import {P} from "@atoms/Text/P";
import './style.scss';
import {Icon} from "@atoms/Media/Icon";
import {FormattedMessage} from 'react-intl';
import {Headline} from '@atoms/Text/Headline';
import {HeadlineLevel} from 'features/ui/enums';

interface Props {
    onStart: () => void
}

export const ApartmentViewerIntro : React.FC<Props> = ({onStart}) => {


    return (
        <div className="apartment-viewer-intro">
            <Headline level={HeadlineLevel.H2}><FormattedMessage id="jm.features.appartmentViewer.welcome" /></Headline>

            <P>
                <FormattedMessage id="jm.features.appartmentViewer.navigationIntro" />
            </P>

            <Button 
                className="apartment-viewer-intro__button" 
                onClick={onStart} 
                icon={<Icon name="apartment-viewer-play" size={40} />} 
                buttonColor={ButtonColor.DEFAULT} 
                buttonSize={ButtonSize.SMALL} 
                buttonType={ButtonType.GHOST} 
            >
                <FormattedMessage id="jm.features.appartmentViewer.visitApartment" />
            </Button>
        </div>
    );
};
